module.exports = __webpack_public_path__ + "vue-app/img/small-2.58137955.jpg";